import { QueryFunctionContext } from "@tanstack/react-query";
import ApiHttpClient from "@/HttpClient";
import {OrganizationModel} from "@/api/Models";

export interface OrganizationResponse extends OrganizationModel { }

export const fetchOrganization = async ({ queryKey }: QueryFunctionContext) => {
  const [, organizationId] = queryKey;
  const { data, status, statusText } = await ApiHttpClient().get<OrganizationResponse>(`/organization/${organizationId}`);

  console.log(`Status ${status} ${statusText}`);
  console.log(JSON.stringify(data, null, 4));
  return data;
}